// extracted by mini-css-extract-plugin
export default {"arrow_style":"AccordionComponent_arrow_style__CJAYC"};